<template>
   <ui-button>
     
      <div slot="left">
        <div class="icon" :class="{'icon-rotate':open}">
          <ui-icon icon="caret-down" backgroundColor="#8CC63E" color="#FFFFFF"/>
        </div>
      </div>
      <div slot="title">{{ $t(title) }}</div>
    </ui-button>
</template>

<script>
import UiButton from '../UiButton.vue';
import UiIcon from '../UiIcon.vue';

export default {
  name: 'button-caret',
  props:{
    title:{default:"no title prop set."},
    open:{default:false}
  },
  data:function(){
    return {
    }
  },
  methods:{
  },
  mounted:function(){
   
  },
  components:{
    UiIcon,
    UiButton
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.icon{
  transform:rotateZ(0deg);
  transition:transform .25s ease-in-out;
  
}
.icon-rotate{
  transform:rotateZ(180deg);
}
</style>
